import { EnumSchema, Executor, FromSchema, ZodUrl } from '@40seas/entities/common';
import { BaseEntity, WithBaseEntitySchema } from '@40seas/models';
import { z } from 'zod';
import { AttachmentType } from './attachment.type.enum';
import { EntityType } from './entity.type.enum';

export const AttachmentSchema = WithBaseEntitySchema(
    z.object({
        buyer: z.string().optional(),
        file: z.string().optional(),
        url: ZodUrl.optional(),
        name: z.string(),
        entityType: EnumSchema(EntityType),
        entityId: z.string(),
        type: EnumSchema(AttachmentType),
    }),
).strict();

export class Attachment extends FromSchema(AttachmentSchema) implements BaseEntity {
    id: string;
    buyer?: string;
    file?: string;
    url?: string;
    name: string;
    entityType: EntityType;
    entityId: string;
    type: AttachmentType;
    createdAt: Date;
    updatedAt: Date;
    tenantId: string;
    createdBy?: Executor;
    seller?: string;
    metadata?: { [key: string]: string };
    timeline?: { [status: string]: { updatedAt: Date } };
}
